import React, {useContext, useEffect, useState} from 'react';
import {Form, message, Modal, Radio} from 'antd';
import Search from 'antd/es/input/Search';
import {sideMenuContext} from '../../../router/IndexRouter';
import {RealtimeGetMethod} from './ApiMethod';

const SearchMemberModal = ({isModalOpen, setIsModalOpen, titleText, searchApi}) => {
	const {currentItem, setCurrentItem} = useContext(sideMenuContext);
	const [searchResult, setSearchResult] = useState([]);
	const [username, setUsername] = useState([]);
	const [allData, setAllData] = useState([]);
	const currentUrl = window.location.href;
	const orgId = (parseInt(sessionStorage.getItem('coffee')) / 20).toString();

	useEffect(() => {
		RealtimeGetMethod(searchApi).then(resultData => {
			let convertedData = [];
			if (resultData?.length > 0) {
				if (searchApi.endsWith('Science.do')) {
					convertedData = resultData.map(item => convertKey(item));
				} else {
					convertedData = resultData;
				}
			}
			setAllData(convertedData);
			setSearchResult(convertedData);
			setUsername(convertedData.map(user => user.partyMemberName || user.memberName));
		});
	}, [orgId]);

	// 将民非研究人员和从业人员中的字段名称转成与 branch_party_branch_member_info 中同义词相同的字段
	const convertKey = (objData) => {
		return Object.keys(objData).map(key => {
			let newKey = key;
			if (key.startsWith('people')) {
				newKey = key.replace('people', 'member');
			} else if (key === 'mbskPost') {
				newKey = 'organizationPost';
			}
			return {[newKey]: objData[key]};
		}).reduce((prev, next) => ({...prev, ...next}));
	};

	const handleCancel = () => {
		form.setFieldsValue({name: ''});
		setIsModalOpen(false);
		setUsername(allData.map(user => user.partyMemberName || user.memberName));
	};

	const handleOk = () => {
		// 如果没有搜索到用户或者没有选择用户，提示错误信息
		if (username.length === 0 || Object.keys(currentItem).length === 0) {
			message.error('没有可新增的人员');
		} else {
			setIsModalOpen(false);
			// 跳转到新增的表单页面
			window.open(currentUrl + '/edit', '_self');
		}
	};

	const onSearch = (userName) => {
		// 从后端接口中请求搜索用户的结果，将完整信息存入 searchResult 中；将提取出来的用户名存入 username 中
		const filterData = allData?.filter(user =>
			user.partyMemberName?.includes(userName) ||
			user.memberName?.includes(userName),
		);
		setSearchResult(filterData);
		setUsername(filterData.map(user => user.partyMemberName || user.memberName));
	};

	const onChange = (e) => {
		// 将当前选中的用户信息保存到 currentItem 中
		setCurrentItem(searchResult[e.target.value]);
	};

	// 将需要展示的用户列表转成字典形式，用于确定所选的是第几个用户
	const nameList = username.map((user, index) => ({label: user, value: index}));

	const [form] = Form.useForm();

	return (
		<Modal title={titleText}
			   open={isModalOpen}
			   onOk={handleOk}
			   onCancel={handleCancel}
			   okText="确定新增">
			<Form form={form}>
				<Form.Item name="name" label="请输入姓名关键字">
					<Search style={{width: 300}} onSearch={onSearch} enterButton/>
				</Form.Item>

				<Radio.Group style={{marginLeft: 13}} onChange={onChange} options={nameList} name="selectName"/>
			</Form>
		</Modal>
	);
};

export default SearchMemberModal;
